export const customProperties = Object.freeze({
  '--font-family-base': "-apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro Display', 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  '--font-size-label': '0.75rem',
  '--line-height-label': '1rem',
  '--font-size-body-sm': '0.875rem',
  '--line-height-body-sm': '1.25rem',
  '--font-size-body': '1rem',
  '--line-height-body': '1.5rem',
  '--font-size-title-sm': '1.125rem',
  '--line-height-title-sm': '1.5rem',
  '--font-size-title': '1.5rem',
  '--line-height-title': '2rem',
  '--font-size-display': '2rem',
  '--line-height-display': '2.375rem',
  '--font-weight-regular': '400',
  '--font-weight-medium': '500',
  '--font-weight-semibold': '600',
  '--space-2xs': '0.25rem',
  '--space-xs': '0.5rem',
  '--space-sm': '0.75rem',
  '--space-md': '1rem',
  '--space-lg': '1.5rem',
  '--space-xl': '2rem',
  '--space-2xl': '2.5rem',
  '--radius-sm': '0.625rem',
  '--radius-md': '0.75rem',
  '--radius-lg': '1rem',
  '--radius-xl': '1.25rem',
  '--radius-2xl': '1.5rem',
  '--radius-control': 'var(--radius-sm)',
  '--radius-chip': 'var(--radius-md)',
  '--radius-card': 'var(--radius-lg)',
  '--radius-panel': 'var(--radius-xl)',
  '--radius-hero': 'var(--radius-2xl)',
  '--shadow-elevated-sm': '0 1px 2px rgba(15, 23, 42, 0.04), 0 1px 3px rgba(15, 23, 42, 0.08)',
  '--shadow-elevated-md': '0 8px 24px rgba(15, 23, 42, 0.08)',
  '--shadow-elevated-xl': '0 20px 48px rgba(15, 23, 42, 0.18)',
  '--color-text-primary': '#0f172a',
  '--color-text-secondary': '#475569',
  '--color-text-muted': '#64748b',
  '--color-text-inverse': '#f8fafc',
  '--color-text-inverse-muted': '#cbd5f5',
  '--color-text-success': '#0f766e',
  '--color-text-danger': '#dc2626',
  '--color-surface-page': '#f8fafc',
  '--color-surface-base': '#ffffff',
  '--color-surface-elevated': 'rgba(248, 250, 252, 0.92)',
  '--color-surface-glass': 'rgba(15, 23, 42, 0.45)',
  '--color-surface-card': 'rgba(15, 23, 42, 0.75)',
  '--color-accent-teal': '#0f766e',
  '--color-accent-teal-soft': 'rgba(15, 118, 110, 0.25)',
  '--color-accent-teal-border': 'rgba(45, 212, 191, 0.4)',
  '--color-accent-teal-strong': '#5eead4',
  '--color-accent-sky': '#0284c7',
  '--color-accent-sky-soft': 'rgba(14, 165, 233, 0.18)',
  '--color-accent-sky-border': 'rgba(125, 211, 252, 0.4)',
  '--color-accent-sky-strong': '#38bdf8',
  '--color-border-subtle': 'rgba(148, 163, 184, 0.3)',
  '--color-border-strong': 'rgba(100, 116, 139, 0.42)',
  '--color-brand-primary': '#0284c7',
  '--color-brand-primary-strong': '#0369a1',
  '--color-brand-primary-soft': 'rgba(14, 165, 233, 0.18)',
  '--color-focus-outline': 'color-mix(in srgb, var(--color-accent-sky) 70%, #f8fafc 15%)',
  '--surface-accent-base': 'color-mix(in srgb, var(--color-surface-card) 86%, rgba(11, 18, 32, 0.92))',
  '--surface-accent-gradient': 'linear-gradient(135deg, color-mix(in srgb, var(--color-surface-card) 92%, transparent) 0%, color-mix(in srgb, var(--color-surface-glass) 88%, var(--color-surface-card) 12%) 45%, color-mix(in srgb, var(--color-accent-sky) 72%, transparent) 100%)',
  '--surface-accent-overlay': 'radial-gradient(circle at 15% 20%, color-mix(in srgb, var(--color-accent-sky) 52%, transparent) 0%, transparent 55%), radial-gradient(circle at 85% 30%, color-mix(in srgb, var(--color-accent-sky-strong) 40%, transparent) 0%, transparent 50%), radial-gradient(circle at 50% 80%, color-mix(in srgb, var(--color-accent-teal-strong) 45%, transparent) 0%, transparent 55%)',
  '--surface-accent-shadow': '0 28px 70px rgba(15, 23, 42, 0.45)',
  '--surface-accent-card': 'color-mix(in srgb, var(--color-surface-glass) 78%, rgba(255, 255, 255, 0.06))',
  '--surface-accent-border': 'color-mix(in srgb, var(--color-accent-sky) 26%, rgba(255, 255, 255, 0.3))',
  '--surface-accent-blur': '22px',
  '--surface-accent-foreground': 'var(--color-text-inverse)',
  '--surface-accent-foreground-muted': 'var(--color-text-inverse-muted)',
  '--surface-accent-icon-primary': 'color-mix(in srgb, var(--color-accent-sky-strong) 70%, #f8fafc 10%)',
  '--surface-accent-icon-secondary': 'color-mix(in srgb, var(--color-accent-teal-strong) 50%, rgba(255, 255, 255, 0.18))',
  '--surface-accent-icon-tertiary': 'color-mix(in srgb, var(--color-surface-glass) 65%, rgba(255, 255, 255, 0.06))',
  '--layout-max-width-wide': '1100px',
  '--form-control-width-compact': '8.75rem',
})

export const modeCustomProperties = Object.freeze({
  "[data-theme='dark']": {
    '--color-text-primary': '#f1f5f9',
    '--color-text-secondary': '#cbd5f5',
    '--color-text-muted': '#94a3b8',
    '--color-surface-page': '#0b1220',
    '--color-surface-base': '#0f172a',
    '--color-surface-elevated': 'rgba(15, 23, 42, 0.82)',
    '--color-surface-glass': 'rgba(15, 23, 42, 0.55)',
    '--color-border-subtle': 'rgba(148, 163, 184, 0.45)',
    '--color-border-strong': 'rgba(148, 163, 184, 0.6)',
    '--surface-accent-base': 'color-mix(in srgb, rgba(11, 18, 32, 0.94) 80%, rgba(2, 6, 23, 0.96) 20%)',
    '--surface-accent-gradient': 'linear-gradient(140deg, color-mix(in srgb, rgba(6, 12, 26, 0.95) 92%, transparent) 0%, color-mix(in srgb, rgba(8, 18, 35, 0.9) 75%, rgba(45, 212, 191, 0.1)) 55%, color-mix(in srgb, var(--color-accent-sky-strong) 45%, rgba(8, 18, 35, 0.65)) 100%)',
    '--surface-accent-overlay': 'radial-gradient(circle at 20% 20%, color-mix(in srgb, var(--color-accent-sky-strong) 36%, transparent) 0%, transparent 60%), radial-gradient(circle at 80% 28%, color-mix(in srgb, var(--color-accent-teal-strong) 45%, transparent) 0%, transparent 55%), radial-gradient(circle at 45% 85%, color-mix(in srgb, rgba(28, 100, 242, 0.8) 48%, transparent) 0%, transparent 60%)',
    '--surface-accent-shadow': '0 32px 90px rgba(2, 6, 23, 0.65)',
    '--surface-accent-card': 'color-mix(in srgb, rgba(15, 23, 42, 0.82) 80%, rgba(8, 145, 178, 0.18))',
    '--surface-accent-border': 'color-mix(in srgb, var(--color-accent-sky) 28%, rgba(255, 255, 255, 0.18))',
    '--surface-accent-icon-primary': 'color-mix(in srgb, var(--color-accent-sky-strong) 65%, rgba(240, 249, 255, 0.75))',
    '--surface-accent-icon-secondary': 'color-mix(in srgb, var(--color-accent-teal-strong) 54%, rgba(45, 212, 191, 0.18))',
    '--surface-accent-icon-tertiary': 'color-mix(in srgb, rgba(15, 23, 42, 0.85) 60%, rgba(148, 163, 184, 0.25))',
  },
})

const spacingTokenMap = Object.freeze({
  paddingXXS: '--space-2xs',
  paddingXS: '--space-xs',
  paddingSM: '--space-sm',
  padding: '--space-md',
  paddingLG: '--space-lg',
  paddingXL: '--space-xl',
  paddingXXL: '--space-2xl',
})

const remPattern = /^(?<value>[0-9]*\.?[0-9]+)rem$/
const pxPattern = /^(?<value>[0-9]*\.?[0-9]+)px$/

function toPxNumber(raw, fallback = 0) {
  const remMatch = raw.match(remPattern)
  if (remMatch?.groups?.value) {
    return Number.parseFloat(remMatch.groups.value) * 16
  }

  const pxMatch = raw.match(pxPattern)
  if (pxMatch?.groups?.value) {
    return Number.parseFloat(pxMatch.groups.value)
  }

  return fallback
}

function createAntdTokenSet(source) {
  const spacingEntries = Object.entries(spacingTokenMap).map(([tokenKey, propertyKey]) => [
    tokenKey,
    toPxNumber(source[propertyKey]),
  ])

  return {
    colorPrimary: source['--color-brand-primary'],
    colorPrimaryHover: source['--color-brand-primary-strong'],
    colorPrimaryActive: source['--color-brand-primary-strong'],
    colorLink: source['--color-brand-primary'],
    colorLinkHover: source['--color-brand-primary-strong'],
    colorLinkActive: source['--color-brand-primary-strong'],
    colorBgBase: source['--color-surface-base'],
    colorBgLayout: source['--color-surface-page'],
    colorBgContainer: source['--color-surface-base'],
    colorBgElevated: source['--color-surface-elevated'],
    colorBorder: source['--color-border-subtle'],
    colorBorderSecondary: source['--color-border-subtle'],
    colorSplit: source['--color-border-subtle'],
    colorTextBase: source['--color-text-primary'],
    colorTextHeading: source['--color-text-primary'],
    colorText: source['--color-text-secondary'],
    borderRadius: toPxNumber(source['--radius-control']),
    borderRadiusSM: toPxNumber(source['--radius-control']),
    borderRadiusLG: toPxNumber(source['--radius-card']),
    fontFamily: source['--font-family-base'],
    fontSize: toPxNumber(source['--font-size-body']),
    fontSizeSM: toPxNumber(source['--font-size-body-sm']),
    fontSizeLG: toPxNumber(source['--font-size-title-sm']),
    fontSizeXL: toPxNumber(source['--font-size-title']),
    fontSizeHeading3: toPxNumber(source['--font-size-title']),
    fontSizeHeading4: toPxNumber(source['--font-size-title-sm']),
    lineHeight: toPxNumber(source['--line-height-body']) / toPxNumber(source['--font-size-body'], 16),
    lineHeightLG: toPxNumber(source['--line-height-title-sm']) / toPxNumber(source['--font-size-title-sm'], 18),
    lineHeightSM: toPxNumber(source['--line-height-body-sm']) / toPxNumber(source['--font-size-body-sm'], 14),
    boxShadow: source['--shadow-elevated-sm'],
    boxShadowSecondary: source['--shadow-elevated-md'],
    boxShadowTertiary: source['--shadow-elevated-xl'],
    sizeUnit: toPxNumber(source['--space-2xs']),
    sizeStep: toPxNumber(source['--space-xs']),
    ...Object.fromEntries(spacingEntries),
  }
}

const baseRecord = {...customProperties}
const darkOverrides = modeCustomProperties["[data-theme='dark']"] || {}

export const antdTokens = Object.freeze({
  light: createAntdTokenSet(baseRecord),
  dark: createAntdTokenSet({...baseRecord, ...darkOverrides}),
})

export const themeTokens = Object.freeze({
  brand: {
    primary: 'var(--color-brand-primary)',
    primaryStrong: 'var(--color-brand-primary-strong)',
    primarySoft: 'var(--color-brand-primary-soft)',
  },
  colors: {
    text: {
      primary: 'var(--color-text-primary)',
      secondary: 'var(--color-text-secondary)',
      muted: 'var(--color-text-muted)',
      inverse: 'var(--color-text-inverse)',
      inverseMuted: 'var(--color-text-inverse-muted)',
      success: 'var(--color-text-success)',
      danger: 'var(--color-text-danger)',
    },
    surface: {
      base: 'var(--color-surface-base)',
      elevated: 'var(--color-surface-elevated)',
      glass: 'var(--color-surface-glass)',
      card: 'var(--color-surface-card)',
    },
    accentSurface: {
      base: 'var(--surface-accent-base)',
      gradient: 'var(--surface-accent-gradient)',
      overlay: 'var(--surface-accent-overlay)',
      shadow: 'var(--surface-accent-shadow)',
      card: 'var(--surface-accent-card)',
      cardBorder: 'var(--surface-accent-border)',
      cardBlur: 'var(--surface-accent-blur)',
      foreground: 'var(--surface-accent-foreground)',
      foregroundMuted: 'var(--surface-accent-foreground-muted)',
      iconPrimary: 'var(--surface-accent-icon-primary)',
      iconSecondary: 'var(--surface-accent-icon-secondary)',
      iconTertiary: 'var(--surface-accent-icon-tertiary)',
    },
    accent: {
      teal: 'var(--color-accent-teal)',
      tealSoft: 'var(--color-accent-teal-soft)',
      tealBorder: 'var(--color-accent-teal-border)',
      tealStrong: 'var(--color-accent-teal-strong)',
      sky: 'var(--color-accent-sky)',
      skySoft: 'var(--color-accent-sky-soft)',
      skyBorder: 'var(--color-accent-sky-border)',
      skyStrong: 'var(--color-accent-sky-strong)',
    },
    border: {
      subtle: 'var(--color-border-subtle)',
      strong: 'var(--color-border-strong)',
    },
    focus: {
      outline: 'var(--color-focus-outline)',
    },
  },
  spacing: {
    '2xs': 'var(--space-2xs)',
    xs: 'var(--space-xs)',
    sm: 'var(--space-sm)',
    md: 'var(--space-md)',
    lg: 'var(--space-lg)',
    xl: 'var(--space-xl)',
    '2xl': 'var(--space-2xl)',
  },
  radii: {
    sm: 'var(--radius-sm)',
    md: 'var(--radius-md)',
    lg: 'var(--radius-lg)',
    xl: 'var(--radius-xl)',
    control: 'var(--radius-control)',
    chip: 'var(--radius-chip)',
    card: 'var(--radius-card)',
    panel: 'var(--radius-panel)',
    hero: 'var(--radius-hero)',
  },
  shadow: {
    sm: 'var(--shadow-elevated-sm)',
    md: 'var(--shadow-elevated-md)',
    xl: 'var(--shadow-elevated-xl)',
  },
  layout: {
    maxWidthWide: 'var(--layout-max-width-wide)',
  },
  form: {
    controlWidthCompact: 'var(--form-control-width-compact)',
  },
  typography: {
    fontFamilyBase: 'var(--font-family-base)',
    fontSizeLabel: 'var(--font-size-label)',
    fontSizeBodySm: 'var(--font-size-body-sm)',
    fontSizeBody: 'var(--font-size-body)',
    fontSizeTitleSm: 'var(--font-size-title-sm)',
    fontSizeTitle: 'var(--font-size-title)',
    fontSizeDisplay: 'var(--font-size-display)',
    lineHeightLabel: 'var(--line-height-label)',
    lineHeightBodySm: 'var(--line-height-body-sm)',
    lineHeightBody: 'var(--line-height-body)',
    lineHeightTitleSm: 'var(--line-height-title-sm)',
    lineHeightTitle: 'var(--line-height-title)',
    lineHeightDisplay: 'var(--line-height-display)',
    fontWeightRegular: 'var(--font-weight-regular)',
    fontWeightMedium: 'var(--font-weight-medium)',
    fontWeightSemibold: 'var(--font-weight-semibold)',
  },
})
